import React from "react";

const MAP = {
  BREAKING: "bg-red-500/15 text-red-400 border-red-500/30",
  DEVELOPING: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  CONFIRMED: "bg-[#ccff00]/15 text-[#ccff00] border-[#ccff00]/30",
  "ON-CHAIN": "bg-blue-500/15 text-blue-400 border-blue-500/30",
  EXCLUSIVE: "bg-fuchsia-500/15 text-fuchsia-400 border-fuchsia-500/30",
  "ONCHAINLYFE INTELLIGENCE": "bg-[#ccff00]/10 text-[#ccff00] border-[#ccff00]/25",
  "ONCHAINLYFE EXCLUSIVE": "bg-[#ccff00]/10 text-[#ccff00] border-[#ccff00]/25",
  // legacy badge values on historical articles (pre-rebrand) keep the same styling
  "CRYPTOLYFE INTELLIGENCE": "bg-[#ccff00]/10 text-[#ccff00] border-[#ccff00]/25",
  "CRYPTOLYFE EXCLUSIVE": "bg-[#ccff00]/10 text-[#ccff00] border-[#ccff00]/25",
  "PRIMARY SOURCE": "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  OFFICIAL: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  "ON-CHAIN VERIFIED": "bg-blue-500/15 text-blue-400 border-blue-500/30",
  "REGULATORY FILING": "bg-indigo-500/15 text-indigo-400 border-indigo-500/30",
  "THIRD-PARTY REPORT": "bg-zinc-500/15 text-zinc-300 border-zinc-500/30",
  UNCONFIRMED: "bg-orange-500/15 text-orange-400 border-orange-500/30",
};

export function CLBadge({ label, className = "" }) {
  const style = MAP[label] || "bg-white/5 text-zinc-300 border-white/10";
  return (
    <span
      data-testid={`badge-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-mono-cl font-semibold tracking-[0.14em] uppercase ${style} ${className}`}
    >
      {label}
    </span>
  );
}

export function TierTag({ tier }) {
  if (!tier || tier === "public") return null;
  const map = {
    member: "bg-white/10 text-zinc-200 border-white/15",
    alpha: "bg-[#ccff00] text-black border-[#ccff00]",
  };
  return (
    <span className={`px-2 py-0.5 rounded-full border text-[10px] font-mono-cl font-bold tracking-[0.16em] uppercase ${map[tier] || map.member}`}>
      {tier}
    </span>
  );
}
